<script setup>
import { ref, onMounted, watch, computed } from 'vue'
import Datepicker from 'flowbite-datepicker/Datepicker'
import { useAuthStore } from '../stores';
import { useRoute } from 'vue-router'

const route = useRoute()
const authStore = useAuthStore();
const firstName = ref('')
const lastName = ref('')
const birthdate = ref('')
const birthMonth = ref('')
const birthYear = ref('')
const gender = ref('')
const pretermWeeks = ref(0)
const premie = ref(false)
let datepicker = null

const date = new Date()

const yearsList = [date.getFullYear()].concat(
    [...Array(8).keys()].map((year, idx) => {
        date.setFullYear(date.getFullYear() - 1)
        return date.getFullYear()
    })
)

const monthsList = [...Array(12).keys()].map(month => {
    date.setMonth(month)
    return { key: date.toLocaleString('default', { month: 'long' }), value: month }
})



watch(route, async (to, prev) => {
    await configureFormValues()
})

const configureFormValues = async () => {
    if (route.params.id) {
        const currChild = authStore.children[route.params.id]
        firstName.value = currChild.first_name
        lastName.value = currChild.last_name
        birthdate.value = currChild.birthdate
        birthYear.value = currChild.birth_year
        birthMonth.value = currChild.birth_month
        gender.value = currChild.gender
        // let date = Date.parse(`${currChild.birthdate}T00:00:00+00:00`)
        // let date = new Date(`${currChild.birthdate}T12:00:00+00:00`)
        // datepicker.setDate(date)
    } else {
        firstName.value = ''
        lastName.value = ''
        birthdate.value = ''
        birthYear.value = ''
        birthMonth.value = ''
        gender.value = ''
        const date = Date.now()
        // datepicker.setDate(date)
    }
}

onMounted(async () => {
    // const datepickerEl = document.getElementById('datepickerId');
    // datepicker = new Datepicker(datepickerEl);
    await configureFormValues()
})

const createChild = () => {
    if (route.params.id) {
        authStore.updateChild(
            route.params.id,
            firstName.value,
            lastName.value,
            gender.value,
            birthYear.value,
            birthMonth.value,
            pretermWeeks.value,
            )
        } else {
            authStore.createChild(
                firstName.value,
                lastName.value,
                gender.value,
                birthYear.value,
                birthMonth.value,
                pretermWeeks.value,
            )
    }
}

const canSave = computed(() => {
    return (firstName.value && birthMonth.value !== '' && birthYear.value) || false
})

const buttonText = computed(() => {
    return  route.params.id ? 'Update' : 'Create'
})

</script>
<template>
    <div class="container flex flex-col items-center mx-auto p-4 md:pt-12">
        <form class=" max-w-xl">
            <div class="grid gap-6 mb-6 ">
                <div>
                    <label class="block mb-2 text-sm font-medium text-gray-900 dark:text-white" for="first_name">First
                        name</label>
                    <input type="text" id="first_name" v-model="firstName"
                        class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                        placeholder="Favorite" required>
                    <label class="block mb-2 mt-2 text-sm font-medium text-gray-900 dark:text-white" for="last_name">Last
                        name</label>
                    <input type="text" id="last_name" v-model="lastName"
                        class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                        placeholder="Kid" required>
                </div>
            </div>
            <div class="grid gap-6 mb-6">
                <div>
                    <label for="email" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Gender</label>
                    <div class="flex">
                        <div class="flex items-center mr-4">
                            <input id="inline-radio" type="radio" value="male" name="inline-radio-group" v-model="gender"
                                class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600">
                            <label for="inline-radio"
                                class="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">Male</label>
                        </div>
                        <div class="flex items-center mr-4">
                            <input id="inline-2-radio" type="radio" value="female" name="inline-radio-group"
                                v-model="gender"
                                class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600">
                            <label for="inline-2-radio"
                                class="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">Female</label>
                        </div>
                        <div class="flex items-center mr-4">
                            <input checked id="inline-checked-radio" type="radio" value="n/a" name="inline-radio-group"
                                v-model="gender"
                                class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600">
                            <label for="inline-checked-radio"
                                class="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">Prefer not to
                                answer</label>
                        </div>
                    </div>
                </div>
                <div v-if="firstName">
                    <div class="flex items-center mb-4">
                        <input id="default-checkbox" type="checkbox" v-model="premie"
                            class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600">
                        <label for="default-checkbox" class="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">Was
                            {{ firstName }} premature?</label>
                    </div>
                    <div v-if="premie">
                        <label class="block mb-2 text-sm font-medium text-gray-900 dark:text-white" for="last_name">Preterm
                            Weeks</label>
                        <input type="number" id="preterm_weeks" v-model="pretermWeeks"
                            class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 "
                            placeholder="0">
                    </div>
                </div>
                <div v-show="firstName">
                    <label for="birthMonth" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Birth
                        month</label>
                    <select id="birthMonth" v-model="birthMonth"
                        class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 ">
                        <option v-for="month in monthsList" :value="month.value" :key="month.key">{{ month.key }}</option>
                    </select>
                    <label for="yearsList" class="block mb-2 mt-2 text-sm font-medium text-gray-900 dark:text-white">Birth
                        year</label>
                    <select id="yearsList" v-model="birthYear"
                        class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 ">
                        <option v-for="year in yearsList" :value="year" :key="year">{{ year }}</option>
                    </select>
                </div>
            </div>
            <button
                :class="canSave ? '' : 'opacity-50 cursor-not-allowed'"
                class="min-w-20 text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full px-5 py-2.5 text-center"
                type="button" :disabled="!canSave" @click="createChild">{{ buttonText }}</button>
        </form>
</div></template>